import { TPurchaseOptionProps } from '@r1-frontend/ui-react/components/costs/PurchaseOptions/types';

import * as ST from './styled';

type TPurchaseOptionsItemProps = {
    isChecked: boolean,
    name?: string,
    customText?: string,
} & TPurchaseOptionProps;

const PurchaseOptionsItem = ({ cost, period, onSelect, isChecked, name = 'PurchaseOption', customText, ...props }: TPurchaseOptionsItemProps) => {
    return (
        <ST.Item
            isChecked={isChecked}
        >
            <ST.ItemRadio
                size={'XS'}
                name={name}
                onChange={onSelect(cost, period)}
                checked={isChecked}
                {...props}
            >
                {customText
                    ? customText
                    : (
                        <ST.TextWrapper>
                            <span>Рассрочка на {period} мес.</span>
                            <br/>
                            <b>{cost} ₽/мес</b>
                        </ST.TextWrapper>
                    )
                }
            </ST.ItemRadio>
        </ST.Item>
    );
};

export default PurchaseOptionsItem;
